export default __webpack_public_path__ + "static/media/basic-push-pin-13.30dbf535.png";